<template>
  <div class="additionalFinancing">
    <div class="d-flex align-items-center">
      <div class="d-flex align-items-center">
        <span class="fa-regular fa-calculator mr-2"></span>
        <strong
          >Propose a payment plan from a lender's loan calculator</strong
        >
      </div>
      <div class="ml-auto d-flex align-items-center">
        <TextField
          id="totalDownPayment"
          v-model="paymentsAsLowAsCents"
          data-cy="totalDownPayment"
          currency
          style="width: 120px"
          class="mb-0 mr-4"
          input-class="text-right"
          no-label
          :error-message="firstErrorMessage(v$.paymentsAsLowAsCents)"
        />
        <Button data-cy="addOffer" primary @click="handleAddOffer">{{
          quote?.payments_as_low_as_cents ? "Update Offer" : "Add Offer"
        }}</Button>
      </div>
    </div>
    <div
      v-if="
        quote?.payments_as_low_as_cents !== null &&
        quote?.payments_as_low_as_cents !== undefined &&
        quote.payments_as_low_as_cents > 0
      "
      class="currentOffer d-flex align-items-center"
    >
      <div>
        <strong class="mr-2">Payments as low as:</strong>
        <strong>{{ dollars(quote?.payments_as_low_as_cents) }}</strong>
      </div>
      <Button
        icon="far fa-trash-alt"
        type="link"
        class="removeOffer btn-plain"
        data-cy="removeOffer"
        @click="handleRemoveOffer"
      >
        Remove Offer
      </Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Button from "@/components/Button.vue";
import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import { useFinancingAvailable } from "./useFinancingAvailable";

const {
  quote,
  handleAddPaymentsAsLowAsOffer,
  handleRemovePaymentsAsLowAsOffer
} = useFinancingAvailable();

const paymentsAsLowAsCents = ref(0);

const v$ = useVuelidate(
  {
    paymentsAsLowAsCents: {
      minValue: helpers.withMessage("Invalid amount", (val: number) => {
        return val > 0;
      }),
      maxValue: helpers.withMessage("Invalid amount", (val: number) => {
        return val < quote.value.financials.total_cents;
      })
    }
  },
  { paymentsAsLowAsCents }
);

async function handleAddOffer() {
  const validated = await v$.value.$validate();
  if (!validated) return;
  await handleAddPaymentsAsLowAsOffer(paymentsAsLowAsCents.value);
  paymentsAsLowAsCents.value = 0;
  v$.value.$reset();
}

async function handleRemoveOffer() {
  await handleRemovePaymentsAsLowAsOffer();
  paymentsAsLowAsCents.value = 0;
  v$.value.$reset();
}
</script>

<style lang="scss" scoped>
.additionalFinancing {
  .fa-calculator {
    font-size: 24px;
  }
  .removeOffer {
    font-size: 14px;
  }
  .currentOffer {
    margin-top: 12px;
    padding-top: 12px;
    border-top: 1px solid #d9d9d9;
  }
}
</style>
